var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#EEF3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5375 10.3202L13.1841 18.3819L10.9675 16.0135C10.5591 15.6285 9.91747 15.6052 9.4508 15.9319C8.9958 16.2702 8.86747 16.8652 9.14747 17.3435L11.7725 21.6135C12.0291 22.0102 12.4725 22.2552 12.9741 22.2552C13.4525 22.2552 13.9075 22.0102 14.1641 21.6135C14.5841 21.0652 22.5991 11.5102 22.5991 11.5102C23.6491 10.4368 22.3775 9.49185 21.5375 10.3085V10.3202Z",
    fill: "#003FB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBullet);
export default __webpack_public_path__ + "static/media/ic_bullet.775cc358d3354e779af48ed5d31eb1a0.svg";
export { ForwardRef as ReactComponent };